import React from "react";
import { Link } from "react-router-dom";
import { GameModeDifficulty } from "../../components/views";

import styles from "./GameMode.module.scss";

const GameMode: React.FC = () => (
  <div className={styles.game_mode}>
    <div className={styles.game_mode__container}>
      <h1 className={styles.game_mode__container__title}>Pathfinder Game</h1>
      <GameModeDifficulty />
      <div className={styles.game_mode__goback}>
        <Link to="/" className={styles.game_mode__goback__link}>
          Go back
        </Link>
      </div>
    </div>
  </div>
);

export default GameMode;
